import { IUser } from '@monetize/types/app';
import { createColumnHelper } from '../../../components/Monetize/DataTableNew/appTable';
import React from 'react';
import { actionCatalogColumn } from '../../../components/Monetize/DataTableNew/columnCatalog/structuralColumns';
import {
  ColumnCatalog,
  ColumnContextBase,
} from '../../../components/Monetize/DataTableNew/columnCatalog/types';
import {
  getColHeaderFilters,
  getColHeaderWithSize,
  nameWithIdBodyTemplate,
  textBodyTemplate,
} from '../../../components/Monetize/DataTableNew/tableUtilsNew';
import { userStatusItems } from '../../../constants/users';

const columnHelper = createColumnHelper<IUser>();

const ROLE_COLUMN_WIDTH = 270;

export interface ManageUsersListColumnContext extends ColumnContextBase<IUser> {
  renderRefs: React.RefObject<{
    actionsTemplate: (rowData: IUser) => React.ReactNode;
    userStatusBodyTemplate: (rowData: IUser) => React.ReactNode;
    roleBodyTemplate: (rowData: IUser) => React.ReactNode;
  }>;
}

/** tableId: FilterStateKeys.USER_LIST */
export const MANAGE_USERS_LIST_CATALOG: ColumnCatalog<
  IUser,
  ManageUsersListColumnContext
> = [
  {
    id: 'name',
    label: 'User',
    customizable: false,
    build: () =>
      columnHelper.accessor('name', {
        ...getColHeaderWithSize('User', 300),
        ...getColHeaderFilters('TEXT'),
        cell: nameWithIdBodyTemplate<IUser, string>({
          nameProp: 'name',
          idProp: 'id',
        }),
        enableSorting: true,
      }),
  },
  {
    id: 'email',
    label: 'Email',
    build: () =>
      columnHelper.accessor('email', {
        ...getColHeaderWithSize('Email', 300),
        ...getColHeaderFilters('TEXT'),
        cell: textBodyTemplate(),
        enableSorting: true,
      }),
  },
  {
    id: 'status',
    label: 'Status',
    build: ({ renderRefs }) =>
      columnHelper.accessor('status', {
        ...getColHeaderWithSize('Status', 180),
        cell: ({ row }) =>
          renderRefs.current?.userStatusBodyTemplate(row.original),
        enableSorting: false,
        ...getColHeaderFilters<IUser>('SET', {
          predefinedFilterValues: userStatusItems,
        }),
      }),
  },
  {
    id: 'roles',
    label: 'Role',
    build: ({ renderRefs }) =>
      columnHelper.display({
        id: 'roles',
        ...getColHeaderWithSize('Role', ROLE_COLUMN_WIDTH),
        cell: ({ row }) => renderRefs.current?.roleBodyTemplate(row.original),
        enableSorting: false,
      }),
  },
  actionCatalogColumn<IUser>(),
];
